module.exports = __webpack_public_path__ + "static/39invgde-b8f2697b67dac12ee6384198072f881d.gif";